import React from "react";

import DynamicTable from "../../../components/DynamicTable";
import { date } from "../formatters";

function ReferralsTable({ data, page, setPage }) {
  return (
    <>
      <DynamicTable
        showAction={false}
        rowKey="id"
        dataSource={data.referrals}
        pagination={{
          current: page + 1,
          pageSize: 50,
          total: data.referral_count,
          showSizeChanger: false,
          onChange: (p) => setPage(p - 1),
        }}
        columns={[
          {
            title: "ID",
            dataIndex: "id",
          },
          {
            title: "Inviter",
            dataIndex: "inviter_id",
          },
          {
            title: "Invited student",
            dataIndex: "invitee_id",
          },
          {
            title: "Campaign",
            dataIndex: "campaign_id",
          },
          {
            title: "State",
            dataIndex: "state",
          },
          {
            title: "Expires",
            dataIndex: "expires_at",
            render: date,
          },
        ]}
      />
    </>
  );
}
export default ReferralsTable;
